const routes = {
    login:'/se-connecter',
    home: '/',
    presentation: '/présentation',
    article: '/article',
    comites: '/comités',
    politique: '/politique-de-publication',
    credits: '/crédits',
    proposition: '/proposition',
    propositionArticle: '/proposition-article',
    contact: '/contacts',
    search: '/recherche',
    rubrique: '/rubrique'
};

export default routes;